import styled from '@emotion/styled';

export const PortaledMenuWrapper = styled.div`
  position: absolute;
  ${({ top = null }) => top !== null && `top: ${top}px;`}
  ${({ left = null }) => left !== null && `left: ${left}px;`}
  ${({ right = null }) => right !== null && `right: ${right}px;`}
`;
